module.exports = __webpack_public_path__ + "img/hero-sns_pow21.2bf4356.jpg";